import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { TrustBadges } from '../components/TrustBadges';
import { WhatWeCarry } from '../components/WhatWeCarry';
import { FeaturedEquipment } from '../components/FeaturedEquipment';
import { WhyChoosePES } from '../components/WhyChoosePES';
import { Reviews } from '../components/Reviews';
import { SellCTA } from '../components/SellCTA';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="w-full min-h-screen bg-brand-dark font-inter overflow-x-hidden" data-id="element-317">
      <Header data-id="element-318" />
      <main data-id="element-319">
        <HeroSection data-id="element-320" />
        <WhatWeCarry data-id="element-321" />
        <FeaturedEquipment data-id="element-322" />
        <WhyChoosePES data-id="element-323" />
        <Reviews data-id="element-324" />
        <SellCTA data-id="element-325" />
        <ContactSection data-id="element-326" />
      </main>
      <TrustBadges data-id="element-327" />
      <Footer data-id="element-328" />
    </div>;
}